module.exports = __webpack_public_path__ + "static/marketing-wp-d1e59460e2192af872ff2392de0b2db0.jpeg";